import Hijack from "../support/Hijack.js";
import useAuth from "../auth/useAuth.js";

import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import {Button, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Tooltip, Box} from '@material-ui/core';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import Edit from '@material-ui/icons/Edit';
import LinkIcon from '@material-ui/icons/Link';

const previewStyles = makeStyles((theme) => ({
    collection: {
        display: "flex",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "60px 0",
        margin: "0",
        gap: "0px 6px",

        "@media (max-width:530px)": {
            "& li:nth-child(2n)": {
                marginLeft: 103,
            },
        },

        "@media (min-width:530px) and (max-width:720px)": {
            "& li:nth-child(4n-1)": {
                marginLeft: 103,
            },
        },

        "@media (min-width:720px) and (max-width:1180px)": {
            "& li:nth-child(6n+4)": {
                marginLeft: 103,
            },
        },

        "@media (min-width:1180px)": {
            "& li:nth-child(7n+5)": {
                marginLeft: 103,
            },
        },
    },
    '@keyframes hexPop': {
        '0%': {
            transform: 'scale(0.85) translateY(20px)',
            opacity: 0
        },
        '100%': {
            transform: 'scale(1) translateY(0px)',
            opacity: 1
        }
    },
    hex: {
        width: "200px",
        height: "230px",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        background: "var(--darkBlue)",
        clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
        marginTop: "-53px",
        marginBottom: "0 !important",
        display: "flex",
        justifyItems: "center",
        alignItems: "center",

        animation: '$hexPop 0.45s ease forwards',
        opacity: 0,

        "& .hex-bg": {
            position: "absolute",
            inset: 0,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: "transform 0.35s ease",
            clipPath: `polygon(
                    50% calc(5px / cos(30deg)), 
                    calc(100% - 5px) calc(25% + 5px * tan(30deg)), 
                    calc(100% - 5px) calc(75% - 5px * tan(30deg)), 
                    50% calc(100% - 5px / cos(30deg)), 
                    calc(0% + 5px) calc(75% - 5px * tan(30deg)), 
                    calc(0% + 5px) calc(25% + 5px * tan(30deg))
                )`,
        },

        "& .hex-overlay": {
            width: "100%",
            height: "100%",
            zIndex: 5,
            background: "#000",
            background: "linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 1) 100%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "1em",
            color: "white",
            fontWeight: 600,
            fontSize: "1.3rem",
            transition: "background 0.25s ease",
            "& .play-button": {
                color: 'white',
                fontSize: '3rem',
                transition: 'font-size 0.25s ease'
            }
        },
       
        "&:hover .hex-bg": {
            transform: "scale(1.1)",
        },

        "&:hover .hex-overlay": {
            background: "rgba(0,0,0,0.45)",
            "& .play-button": {
                fontSize: "4rem"
            }
        },
    },
    playButton: {
        
    }
}));

function HexPagePreviewGrid({ pages, uneditable }) {
    const classes = previewStyles();

    return (
        <ul className={classes.collection}>
            {pages.map((p,i) => <HexPagePreview key={p.id} page={p} uneditable={uneditable} index={i} />)}
        </ul>
    );
}

function MiniButton({ help, icon, link }) {
    return <Tooltip title={help}>
        <Button size="small" style={{ padding: '4px', margin: 0, color: 'white', minWidth: 'auto' }} color="primary" component={RouterLink} to={link}>{icon}</Button>
    </Tooltip>;
}

function HexPagePreview({ page, uneditable, index }) {
    const auth = useAuth();
    const classes = previewStyles();
    const [videoOpen, setVideoOpen] = useState(false);
    const videoRef = useRef(null);

    const [canContribute, setCanContribute] = useState(false);
    const [canApprove, setCanApprove] = useState(false);

    useEffect(() => {
        if (page) {
            if (page.area == "article" || page.area == "showcase" || page.area == "collection" || page.area == "page" || page.area == "unlisted" || page.area == "renaissance_showcase" || page.area == "renaissance_events") {
                setCanContribute(auth.user.id && auth.user?.roles && auth.user.roles.indexOf(page.area + ".contributor") !== -1);
                setCanApprove(auth.user.id && auth.user?.roles && auth.user.roles.indexOf(page.area + ".approver") !== -1);
            } else if (page.area != "search" && auth.user.id && auth.user?.roles && auth.user.roles.indexOf("admin") !== -1) {
                setCanContribute(true);
                setCanApprove(true);
            }
        }
    }, [auth, page]);

    return <li className={classes.hex} style={{ animationDelay: `${index * 60}ms` }} onClick={() => page?.video ? setVideoOpen(true) : null} >
        <div className="hex-bg" style={{ backgroundImage: page?.thumbnail ? `url(${page.thumbnail})` : undefined }} />

        <div className="hex-overlay">
            <Box style={{ width: '100%' }}>
                {(canContribute && uneditable !== true) ? <MiniButton help="Make changes to the page" icon={<Edit />} link={"/" + page.area + "/" + page.id + "/edit"} />  : ""}
                {canApprove ? <MiniButton help="View page" icon={<LinkIcon />} link={"/" + page.area  + "/" + (page.url || page.family)} /> : null}
                {page.state == "workflow" ? (<Chip label={"Workflow"} variant="outlined" size="small" style={{ margin: 0, padding: 0, fontSize: 8 }} />) : ""}
                {page.redirect ? (<Chip label={"Redir"} className={classes.chipWarn} size="small" style={{ margin: 0, padding: 0, fontSize: 8 }} />) : ""}
            </Box>

            <PlayCircleOutlineIcon className='play-button' />

            <Box style={{ fontSize: "0.7em", lineHeight: "1.2em",  marginTop: "0.5em" }}>{page?.title}</Box>
        </div>

        {page?.video && (
            <Dialog open={videoOpen} fullWidth={true} onClose={() => setVideoOpen(false)} aria-labelledby={"form-dialog-video-" + page.id}>
                <DialogTitle id={"form-dialog-video-" + page.id}>{page.title}</DialogTitle>
                <DialogContent>
                    <Hijack><div ref={videoRef} dangerouslySetInnerHTML={{ __html: page?.video ?? "" }}/></Hijack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={e => { e.stopPropagation(); setVideoOpen(false); }} color="primary">Ok</Button>
                </DialogActions>
            </Dialog>
        )}
    </li>;
}

export { HexPagePreview, HexPagePreviewGrid };
